/* eslint-disable no-param-reassign */
export default {
  state: [],
  selectors: (slice) => ({
    payments: () =>
      slice((state) =>
        state.map((data, index) => ({
          ...data,
          index,
          key: `${index}${data.wallet}${data.cost}${data.payment}${data.returns}`,
        })),
      ),
  }),
  reducers: {
    clear: () => [],
    save: (state, payload) => {
      state.unshift({
        timestamp: new Date(),
        wallet: payload.wallet,
        cost: payload.cost,
        payment: payload.payment,
        returns: payload.returns,
      });
    },
    delete: (state, index) => state.filter((_, i) => i !== index),
  },
};
